import React from 'react';
import style from './croppedImage.module.scss';
import { CachedImage, CachedImageProps } from 'acscp/components/common/cachedImage';

interface CroppedImageProps {
    ratio: number;
}

function croppedImageStyle(ratio: number): {} {
    return {
        padding: `${100 / ratio / 2}% 0 ${100 / ratio / 2}% 0`,
    };
}

const CroppedImage: React.SFC<CroppedImageProps & CachedImageProps> = ({ ratio, ...rest }) =>
(
    <div className={style.CroppedImage} style={croppedImageStyle(ratio)}>
        <CachedImage {...rest} />
    </div>
);

export { CroppedImage };
